import React, { useState } from 'react';

interface IdentityGateProps {
  tenant: string;
  brandName?: string;
  primaryColor?: string;
  onComplete: (name: string, phone: string) => void;
}

const PHONE_REGEX = /^(0\d{9}|\+84\d{9})$/;

export const IdentityGate: React.FC<IdentityGateProps> = ({
  tenant,
  brandName,
  primaryColor = '#dc2626',
  onComplete,
}) => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [nameError, setNameError] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const validateName = (v: string): string => {
    if (!v.trim()) return 'Vui long nhap ho ten';
    if (v.trim().length < 2) return 'Ho ten phai co it nhat 2 ky tu';
    return '';
  };

  const validatePhone = (v: string): string => {
    const cleaned = v.replace(/\s+/g, '');
    if (!cleaned) return 'Vui long nhap so dien thoai';
    if (!PHONE_REGEX.test(cleaned)) return 'So dien thoai khong hop le (VD: 0912345678)';
    return '';
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);

    const nErr = validateName(name);
    const pErr = validatePhone(phone);
    setNameError(nErr);
    setPhoneError(pErr);

    if (nErr || pErr) return;

    const cleanedPhone = phone.replace(/\s+/g, '');
    const trimmedName = name.trim();

    localStorage.setItem(`qbrains:${tenant}:customer_name`, trimmedName);
    localStorage.setItem(`qbrains:${tenant}:customer_phone`, cleanedPhone);

    onComplete(trimmedName, cleanedPhone);
  };

  return (
    <div className="h-full flex flex-col bg-white">
      {/* Header */}
      <div
        className="shrink-0 px-4 py-3 text-white"
        style={{ backgroundColor: primaryColor }}
      >
        <p className="text-sm font-semibold">{brandName || tenant}</p>
      </div>

      {/* Form */}
      <div className="flex-1 flex items-center justify-center px-5">
        <form onSubmit={handleSubmit} className="w-full max-w-xs space-y-4">
          <div className="text-center mb-2">
            <p className="text-sm text-gray-700 font-medium">
              Vui long cho biet thong tin de chung toi ho tro tot hon
            </p>
          </div>

          {/* Name */}
          <div>
            <label htmlFor="ig-name" className="block text-xs font-medium text-gray-600 mb-1">
              Ho ten <span className="text-red-500">*</span>
            </label>
            <input
              id="ig-name"
              type="text"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
                if (submitted) setNameError(validateName(e.target.value));
              }}
              placeholder="Nguyen Van A"
              className={`w-full px-3 py-2 text-sm border rounded-lg focus:outline-none focus:ring-1 ${
                nameError
                  ? 'border-red-400 focus:ring-red-400'
                  : 'border-gray-300 focus:ring-gray-400 focus:border-gray-400'
              }`}
              autoFocus
            />
            {nameError && (
              <p className="text-xs text-red-500 mt-1">{nameError}</p>
            )}
          </div>

          {/* Phone */}
          <div>
            <label htmlFor="ig-phone" className="block text-xs font-medium text-gray-600 mb-1">
              So dien thoai <span className="text-red-500">*</span>
            </label>
            <input
              id="ig-phone"
              type="tel"
              value={phone}
              onChange={(e) => {
                setPhone(e.target.value);
                if (submitted) setPhoneError(validatePhone(e.target.value));
              }}
              placeholder="0912345678"
              className={`w-full px-3 py-2 text-sm border rounded-lg focus:outline-none focus:ring-1 ${
                phoneError
                  ? 'border-red-400 focus:ring-red-400'
                  : 'border-gray-300 focus:ring-gray-400 focus:border-gray-400'
              }`}
            />
            {phoneError && (
              <p className="text-xs text-red-500 mt-1">{phoneError}</p>
            )}
          </div>

          {/* Submit */}
          <button
            type="submit"
            className="w-full py-2.5 text-sm font-medium text-white rounded-lg transition-colors"
            style={{ backgroundColor: primaryColor }}
          >
            Bat dau tro chuyen
          </button>
        </form>
      </div>
    </div>
  );
};
